import React from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { useLanguage } from './LanguageContext';

// Убрали импорт картинки матраса и глобуса отсюда
import mainLogo from './assets/logo-main.png';
import chatIcon from './assets/chat-icon.png';

const MainContent = ({ onOpenForm }) => {
    const { t } = useLanguage();

    const handleChatClick = () => {
        // Находим кнопку чат-бота и кликаем по ней
        const chatButton = document.querySelector('.chatbot-toggle');
        if (chatButton) {
            chatButton.click();
        }
    };

    return (
        // Теперь это просто контейнер для контента
        <main className="main-content-area">
            <img src={mainLogo} alt="AI-SON Mattress Factory" className="main-logo" />
            <p className="tagline">
                {t('tagline')}
            </p>
            <div className="comfort-line">
                <p>{t('comfort')}</p>
            </div>
            <div className="cta-section">
                <button className="cta-button" onClick={onOpenForm}>
                    {t('getConsultation')}
                    <FaArrowRight />
                </button>
                <img 
                    src={chatIcon} 
                    alt="Chat" 
                    className="chat-icon" 
                    onClick={handleChatClick}
                />
            </div>
        </main>
    );
};

export default MainContent;